import styles from "./ContextSelection.module.css";

/** Initial estimate for item rows (tight padding); measureElement refines. */
export const ROW_HEIGHT = 40;

/** Initial estimate for section headers; measureElement refines. */
export const HEADER_HEIGHT = 26;

/** Divider + Add row; subtract from list `maxHeight` when footer is visible. */
export const ADD_FOOTER_HEIGHT = 44;

export { styles };
